<template>
	<div id="app" v-cloak>

		<router-view />
		<!--foot baner-->
		<van-tabbar v-if="showtabBarFlag" v-model="foot_bar_active" active-color="#ee0a24" inactive-color="#000">
			<van-tabbar-item icon="home-o" to="../index/homePage" >首页</van-tabbar-item>
			<!-- 
			<van-tabbar-item icon="shop-o" to="../pharmacy/indexPage">商城</van-tabbar-item>
			<van-tabbar-item icon="shield-o" to="../insurance/indexPage">服务</van-tabbar-item>
			-->
			<van-tabbar-item icon="user-o" to="../my/indexPage">我的</van-tabbar-item>
		</van-tabbar> 	
	</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'


export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
	return {
		foot_bar_active:0,
		showNavBar:false,

		showtabBarFlag:false,

		showBackIcoUrlList:[
			'/index/homePage',
			'/pharmacy/indexPage',
			'/insurance/indexPage',
			'/my/indexPage',
		],
		//无需登录的url
		notReqLoginUrlList:[
			'/login/loginPage',
			'/login/fromWxPage',
			'/outer/abcPage',
			'/outer/nearestDurgPage',
		],
		//需要显示底部bar的url
		reqViewFooterBarUrlList:[
			'/my/indexPage',
			'/index/homePage',
		]			
	}
  },
  watch: {
    '$route'(to, from) {
		console.log("crul:"+from);
      // 根据路由路径决定是否显示 navBar
      this.showNavBar = !this.showBackIcoUrlList.includes(to.path); // 例如，首页不显示 navBar
	  if(to.path){
		  if(to.path.startsWith("/index/homePage")){
			  this.foot_bar_active =0;
		  }
		 if(to.path.startsWith("/my/indexPage")){
			  this.foot_bar_active =1;
		  }
	  }
    },
  },
  methods: {
	goback(){
		this.canGoBack();
		this.$router.back();
		//history.go(-1)
	},
	canGoBack() {
		console.log('back',this.$router.history)
    //   return this.$router.options.history.state.back !== null;
    },
	 watchRoute(to, from) {
		 console.log("from:"+from.path);
		 console.log("to:"+to.path);

		this.reqViewFooterBar(to.path);

		this.loginedProcess(to.path);


      	this.showNavBar = !this.showBackIcoUrlList.includes(to.path); // 你可以根据需要修改这个逻辑

	  //判断用户未登录，就进行绑定
    },
	 //是否登录处理
	loginedProcess(path){
		if(!this.notReqLoginUrlList.includes(path)){
			let lysCstUserId = sessionStorage.getItem('lysCstUserId');
			if(!lysCstUserId){
				 this.$router.push({ path: '/login/loginPage' });
			}
		}
	},

	reqViewFooterBar(path){

		if(this.reqViewFooterBarUrlList.includes(path)){
			this.showtabBarFlag = true;
		}else{
			this.showtabBarFlag = false;
		}
	}
  },created() {
	  let tempPath = this.$route.path;
	  console.log("11crul:"+tempPath);
	  
	  this.reqViewFooterBar(tempPath);

	  this.loginedProcess(tempPath);
	  

	  this.$watch('$route', this.watchRoute);
  }
}
</script>

<style>
	[v-cloak] {
		display: none;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 10px;
	}
	body{
	background-color: #FBFBFB;

	}
</style>
